import { useStoreActions, useStoreState } from '@/store';

export const useExtensionHelper = () => {
    const display = useStoreState((state) => state.extensionModel.display);
    const setDisplay = useStoreActions((actions) => actions.extensionModel.setDisplay);

    const style = useStoreState((state) => state.extensionModel.style);
    const setStyle = useStoreActions((actions) => actions.extensionModel.setStyle);

    const type = useStoreState((state) => state.extensionModel.type);
    const setType = useStoreActions((actions) => actions.extensionModel.setType);

    return {
        display,
        setDisplay,
        style,
        setStyle,
        type,
        setType,
    };
};
